import { render, staticRenderFns } from "./NewAuthorizationLayout.vue?vue&type=template&id=379f938c&scoped=true"
import script from "./NewAuthorizationLayout.vue?vue&type=script&lang=js"
export * from "./NewAuthorizationLayout.vue?vue&type=script&lang=js"
import style0 from "./NewAuthorizationLayout.vue?vue&type=style&index=0&id=379f938c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f938c",
  null
  
)

export default component.exports